const STORAGE_PREFIX = "bx-tour-";

export const tourStorage = {
  getCompletedTours: (): string[] => {
    if (typeof window === "undefined") return [];
    const stored = localStorage.getItem(`${STORAGE_PREFIX}completed`);
    return stored ? JSON.parse(stored) : [];
  },

  setTourCompleted: (tourId: string): void => {
    const completed = tourStorage.getCompletedTours();
    if (!completed.includes(tourId)) {
      localStorage.setItem(
        `${STORAGE_PREFIX}completed`,
        JSON.stringify([...completed, tourId])
      );
    }
  },

  hasTourBeenCompleted: (tourId: string): boolean => {
    return tourStorage.getCompletedTours().includes(tourId);
  },

  resetAllTours: (): void => {
    localStorage.removeItem(`${STORAGE_PREFIX}completed`);
  },

  resetTour: (tourId: string): void => {
    const completed = tourStorage.getCompletedTours();
    localStorage.setItem(
      `${STORAGE_PREFIX}completed`,
      JSON.stringify(completed.filter((id) => id !== tourId))
    );
  },

  // Intro video methods
  hasWatchedIntroVideo: (): boolean => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(`${STORAGE_PREFIX}video-watched`) === "true";
  },

  setIntroVideoWatched: (): void => {
    localStorage.setItem(`${STORAGE_PREFIX}video-watched`, "true");
  },

  resetIntroVideo: (): void => {
    localStorage.removeItem(`${STORAGE_PREFIX}video-watched`);
  },
};
